type Region = 'US' | 'AUS' | 'AU'

const regionMapping: Record<Region, string> = {
	US: 'US',
	AUS: 'AU',
	AU: 'AU',
}

const defaultCountryFromRegion = (region: string): string => {
	return regionMapping[region as Region] ?? 'US'
}

export { defaultCountryFromRegion }
